import React from "react";
import { isArray } from "lodash";
import { _getBaseUrl, _getTranslation } from "../utils/helper";

const CardPublication = ({ data, ...props }) => {
  const imageURL =
    data.image || _getBaseUrl("src/assets/dummy/placeholder.jpg", true);

  return (
    <div className="flex gap-x-4 sm:block rounded-sm sm:rounded-md content-card--link">
      <a href={data.permalink} className="block group">
        <div className="w-[90px] sm:w-full flex-shrink-0">
          <div className="aspect-[29/16] relative overflow-hidden hidden sm:block">
            <div
              className="aspect-[29/12] rounded-sm sm:rounded-md"
              style={{
                backgroundColor: data.cardColor,
              }}
            ></div>
            <img
              src={imageURL}
              alt=""
              className="w-[34%] 2xl:w-[38%] rounded-sm absolute top-2 right-2"
            />
          </div>

          <img
            src={imageURL}
            alt=""
            className="w-full rounded-sm border border-solid border-ideaListGrey100 sm:hidden"
          />
        </div>
        <div className="hidden sm:block sm:w-full sm:-mt-6 lg:mt-0 xl:-mt-4">
          <div
            className="content-card--date transition-all duration-200 group-hover:text-ideaBlue100"
            dangerouslySetInnerHTML={{
              __html: data.publishedDate
                ? `${_getTranslation("published")} ${data.publishedDate}`
                : "&nbsp;",
            }}
          ></div>

          {data.title && (
            <h3 className="content-card--heading transition-all duration-200 group-hover:text-ideaBlue100">
              {data.title}
            </h3>
          )}
        </div>
      </a>

      <div className="flex-grow flex flex-col gap-y-2">
        <a href={data.permalink} className="sm:hidden">
          <div className="content-card--date">
            {data.publishedDate ? `${_getTranslation("published")} ${data.publishedDate}` : ""}
          </div>
          {data.title && (
            <h3 className="content-card--heading">{data.title}</h3>
          )}
        </a>

        {isArray(data.languages) && data.languages.length > 0 && (
          <div className="content-card--languages">
            {data.languages.map((lang, i) => (
              <React.Fragment>
                <a
                  href={`${lang.permalink}${
                    lang.code !== "en" ? "?lang=" + lang.code : ""
                  }`}
                  target="_blank"
                >
                  {lang.label}
                </a>
                {i < data.languages.length - 1 ? ", " : null}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>

      {isArray(data.tags) && data.tags.length > 0 && (
        <div className="content-tags-wrapper hidden sm:flex flex-wrap justify-start">
          {data.tags.map((tag, i) => (
            <React.Fragment>
              <a className="content-tag" href={tag.permalink}>
                {tag.name}
              </a>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default CardPublication;
